import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logoSQR.png'


const _withScopeId = n => (_pushScopeId("data-v-059400ad"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "general" }
const _hoisted_2 = { class: "flex-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "timbrado",
  src: _imports_0
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "encabezado" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "titulocentro" }, " Clínica Cruz Jiminián "),
  /*#__PURE__*/_createElementVNode("h5", { class: "titulocentro" }, " Av. Ortega y Gasset, No. 90, Santo Domingo, Rep. Dom. "),
  /*#__PURE__*/_createElementVNode("h5", { class: "titulocentro" }, " 809-566-2271 "),
  /*#__PURE__*/_createElementVNode("h5", { class: "titulocentro" }, " RNC: 101149868 ")
], -1))
const _hoisted_5 = {
  class: "encabezado",
  style: {"margin-top":"18px"}
}
const _hoisted_6 = { class: "titulocentro" }
const _hoisted_7 = { class: "titulocentro" }
const _hoisted_8 = { class: "titulocentro" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "form-label" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label2" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Datos del Prestador")
], -1))
const _hoisted_12 = { class: "grid" }
const _hoisted_13 = { class: "field" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Nombre: ", -1))
const _hoisted_15 = { class: "field" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Código: ", -1))
const _hoisted_17 = {
  key: 0,
  class: "field"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Médico: ", -1))
const _hoisted_19 = {
  key: 1,
  class: "field"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Especialidad: ", -1))
const _hoisted_21 = {
  key: 2,
  class: "field"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Exequatur: ", -1))
const _hoisted_23 = {
  key: 3,
  class: "field"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Teléfono: ", -1))
const _hoisted_25 = { class: "field" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "NAF: ", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label2" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Datos de la Reclamación")
], -1))
const _hoisted_28 = { class: "grid-3" }
const _hoisted_29 = { class: "field" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Nombre de la ARS: ", -1))
const _hoisted_31 = { class: "field" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Autorización: ", -1))
const _hoisted_33 = { class: "field" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Autorizado Por: ", -1))
const _hoisted_35 = { class: "field" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Fecha: ", -1))
const _hoisted_37 = { class: "field" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Ingreso: ", -1))
const _hoisted_39 = { class: "field" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Egreso: ", -1))
const _hoisted_41 = { class: "grid" }
const _hoisted_42 = { class: "field" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Monto Total: ", -1))
const _hoisted_44 = { class: "field" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Monto Cobertura: ", -1))
const _hoisted_46 = { class: "field" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Monto Copago: ", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label2" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Datos del Caso")
], -1))
const _hoisted_49 = { class: "grid" }
const _hoisted_50 = { class: "field" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Nombre del Paciente: ", -1))
const _hoisted_52 = { class: "field" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Cédula: ", -1))
const _hoisted_54 = { class: "field" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Afiliado o NSS: ", -1))
const _hoisted_56 = { class: "field" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Sexo: ", -1))
const _hoisted_58 = { class: "field" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Edad: ", -1))
const _hoisted_60 = { class: "field" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Dirección: ", -1))
const _hoisted_62 = { class: "field" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Diagnóstico: ", -1))
const _hoisted_64 = /*#__PURE__*/_createStaticVNode("<br data-v-059400ad><br data-v-059400ad><br data-v-059400ad><br data-v-059400ad><br data-v-059400ad><br data-v-059400ad><div class=\"flex-container2\" data-v-059400ad><div data-v-059400ad><p class=\"field bold\" data-v-059400ad>________________________________</p><p class=\"field bold\" data-v-059400ad>Firma y Sello del PSS</p></div><div data-v-059400ad><p class=\"field bold\" data-v-059400ad>________________________________</p><p class=\"field bold\" data-v-059400ad>Firma del Familiar o Paciente</p></div></div><br data-v-059400ad><br data-v-059400ad><br data-v-059400ad>", 10)
const _hoisted_74 = { class: "field clausule" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h4", _hoisted_6, "Fecha: " + _toDisplayString(_ctx.formatDate(this.fechaActual)), 1),
        _createElementVNode("h4", _hoisted_7, "Hora: " + _toDisplayString(_ctx.formatTime(this.fechaActual)), 1),
        _createElementVNode("h4", _hoisted_8, "Factura No.: " + _toDisplayString(this.reclamo.facNo), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("label", _hoisted_10, [
        _createElementVNode("b", null, _toDisplayString(this.titulo), 1)
      ]),
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("p", _hoisted_13, [
          _hoisted_14,
          _createTextVNode(_toDisplayString(_ctx.reclamo.nombPres), 1)
        ]),
        _createElementVNode("p", _hoisted_15, [
          _hoisted_16,
          _createTextVNode(_toDisplayString(_ctx.reclamo.codPres), 1)
        ]),
        (this.reclamo.tipo == 'cent')
          ? (_openBlock(), _createElementBlock("p", _hoisted_17, [
              _hoisted_18,
              _createTextVNode(_toDisplayString(_ctx.reclamo.med), 1)
            ]))
          : _createCommentVNode("", true),
        (this.reclamo.tipo == 'med')
          ? (_openBlock(), _createElementBlock("p", _hoisted_19, [
              _hoisted_20,
              _createTextVNode(_toDisplayString(_ctx.reclamo.espec), 1)
            ]))
          : _createCommentVNode("", true),
        (this.reclamo.tipo == 'med')
          ? (_openBlock(), _createElementBlock("p", _hoisted_21, [
              _hoisted_22,
              _createTextVNode(_toDisplayString(_ctx.reclamo.exeq), 1)
            ]))
          : _createCommentVNode("", true),
        (this.reclamo.tipo == 'med')
          ? (_openBlock(), _createElementBlock("p", _hoisted_23, [
              _hoisted_24,
              _createTextVNode(_toDisplayString(_ctx.reclamo.telMed), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("p", _hoisted_25, [
          _hoisted_26,
          _createTextVNode(_toDisplayString(_ctx.reclamo.naf), 1)
        ])
      ]),
      _hoisted_27,
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("p", _hoisted_29, [
          _hoisted_30,
          _createTextVNode(_toDisplayString(_ctx.reclamo.nombARS), 1)
        ]),
        _createElementVNode("p", _hoisted_31, [
          _hoisted_32,
          _createTextVNode(_toDisplayString(_ctx.reclamo.aut), 1)
        ]),
        _createElementVNode("p", _hoisted_33, [
          _hoisted_34,
          _createTextVNode(_toDisplayString(_ctx.reclamo.autPor), 1)
        ]),
        _createElementVNode("p", _hoisted_35, [
          _hoisted_36,
          _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.reclamo.fechAutor)), 1)
        ]),
        _createElementVNode("p", _hoisted_37, [
          _hoisted_38,
          _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.reclamo.ing)), 1)
        ]),
        _createElementVNode("p", _hoisted_39, [
          _hoisted_40,
          _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.reclamo.egr)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_41, [
        _createElementVNode("p", _hoisted_42, [
          _hoisted_43,
          _createTextVNode(_toDisplayString(_ctx.formatNumber(_ctx.reclamo.montRec)), 1)
        ]),
        _createElementVNode("p", _hoisted_44, [
          _hoisted_45,
          _createTextVNode(_toDisplayString(_ctx.formatNumber(_ctx.reclamo.montRec)), 1)
        ]),
        _createElementVNode("p", _hoisted_46, [
          _hoisted_47,
          _createTextVNode(_toDisplayString(_ctx.formatNumber(_ctx.reclamo.montRec)), 1)
        ])
      ]),
      _hoisted_48,
      _createElementVNode("div", _hoisted_49, [
        _createElementVNode("p", _hoisted_50, [
          _hoisted_51,
          _createTextVNode(_toDisplayString(_ctx.reclamo.nombPac), 1)
        ]),
        _createElementVNode("p", _hoisted_52, [
          _hoisted_53,
          _createTextVNode(_toDisplayString(_ctx.reclamo.cedu), 1)
        ]),
        _createElementVNode("p", _hoisted_54, [
          _hoisted_55,
          _createTextVNode(_toDisplayString(_ctx.reclamo.aflNSS), 1)
        ]),
        _createElementVNode("p", _hoisted_56, [
          _hoisted_57,
          _createTextVNode(_toDisplayString(_ctx.reclamo.sex), 1)
        ]),
        _createElementVNode("p", _hoisted_58, [
          _hoisted_59,
          _createTextVNode(_toDisplayString(_ctx.reclamo.edad), 1)
        ]),
        _createElementVNode("p", _hoisted_60, [
          _hoisted_61,
          _createTextVNode(_toDisplayString(_ctx.reclamo.dir), 1)
        ]),
        _createElementVNode("p", _hoisted_62, [
          _hoisted_63,
          _createTextVNode(_toDisplayString(_ctx.reclamo.dx), 1)
        ])
      ]),
      _hoisted_64,
      _createElementVNode("div", null, [
        _createElementVNode("p", _hoisted_74, " Por este medio autorizo a la CLINICA CRUZ JIMINIAN, a suministrar toda información que sea solicitada por " + _toDisplayString(this.reclamo.nombARS) + ", correspondiente a todo tratamiento, servicio, estudio, laboratorio, diagnóstico o beneficios prestador a mi favor. ", 1)
      ])
    ])
  ]))
}